import React, { useState } from 'react';
import cssClasses from './SelectCrmUserModal.module.css';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../../Subcomponents/Button';
import DropDown from '../../../Subcomponents/DropDown';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CustomAutoComplete from '../../../Subcomponents/CustomAutoComplete';
import ConfirmationAlert from '../../../Subcomponents/ConfirmationAlert';
import { errorTost, successTost } from '../../../Services/Toast';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { insertCRMLogs } from '../../../Services/AllAllotments';
import { updateToCRMTable } from '../../../Services/Users';
import { useSelector } from 'react-redux';

function SelectCrmUserModal({open, handleClose, crmUsersList, heading, allotment}) {

  console.log({crmUsersList});

  const [selectedCrmUser, setSelectedCrmUser] = useState(null);
  const [selectedCrmUserHelperText, setSelectedCrmUserHelperText] = useState("");
  const [openAlertBox, setOpenAlertBox] = useState(false);
  const loggedInUser = useSelector((state) => state.Auth.user);

  function submitHandler() {
    if(heading === "Reassign CRM"){
      setOpenAlertBox(true);
    }else{
      handleClose({flag: true, selectedCrmUser})  
    }
  }

  async function handleReassignCRM() {
    presentLoader();
    let crmUser = selectedCrmUser?.value;
    let crmUserId  = crmUsersList[crmUsersList.findIndex((el) => el.label === crmUser)].userId;

    updateToCRMTable(crmUserId, allotment?.allotment_payment_id).then(async (res) => {
      console.log("Res", res);
      const crmUserName = crmUsersList[crmUsersList.findIndex((el) => el.label === crmUser)].name;
      const crmObj = {
        message : `CRM user of allotment unit ${allotment?.unit_no} of Project ${allotment?.project_name} is changed from ${allotment?.crm_user_name} to ${crmUserName} by ${loggedInUser?.name}`,
        allotmentPaymentId: res?.[0]?.allotmentPaymentId,
        crmStatus: "CRM reassigned"
      }
      insertCRMLogs(crmObj).then((res) => {
        console.log("Logs saved", res);
        successTost("CRM Reassigned Successfully")
        setOpenAlertBox(false);
        handleClose();
      }).catch((err) => {
        console.log(err);
        errorTost("Error while CRM Reassigned")
        dismissLoader();
        setOpenAlertBox(false);
        handleClose();
        dismissLoader();
      })
    }).catch((err) => {
      console.log(err);
      errorTost("Error while CRM Reassigned")
      setOpenAlertBox(false);
      handleClose();      
      dismissLoader();
    })
  }


  return (
    <>
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root":{
            background: "rgba(193, 201, 210, 0.7)"
          }
        }
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          {/* <img src={MessageIcon} alt="" /> */}
          <h1>{heading}</h1>
          {/* <img src={crossImage} alt="" style={{cursor:"pointer"}} onClick={handleClose}/> */}
          <IconButton className={cssClasses.crossButton} onClick={handleClose}> <CloseIcon /> </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
            <Box className={cssClasses.inputContainer}>
              <Typography sx={[labelStyle]}>CRM User</Typography>
              <CustomAutoComplete
                NoOptionsText={'No user found'}
                InitialValue={(_value) => {
                  if (_value) {
                    setSelectedCrmUser(_value);
                    setSelectedCrmUserHelperText("")
                  } else {
                    setSelectedCrmUser("")
                    setSelectedCrmUserHelperText("Please select CRM user.");
                  }
                }}
                list={crmUsersList}
                multiple={false} disable={false}
                value={selectedCrmUser}
                helperText={selectedCrmUserHelperText}
                />
              
              { selectedCrmUser !== null && (crmUsersList.find(f => f?.value === selectedCrmUser?.value)?.crmUserDocUrl?.length === 0) && 
                <Box mt={"2rem"} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                  <WarningAmberRoundedIcon color={"warning"} style={{width: "4rem", height: "4rem"}}/>
                  <Typography style={{...labelStyle, marginLeft: "1rem", marginBottom: "unset"}}>Documents were not found for this CRM user.</Typography>
                </Box>
              }
            </Box>
        </div>

        <div className={cssClasses.footer}>
          {/* <div><Button style={{ color: "#7F56D9", backgroundColor: "#ffffff" }} btnName={"Download PDF"} clicked={handleClose} /></div> */}
          <div><Button style={{ color: "#344054", backgroundColor: "#ffffff" }} btnName={"Cancel"} clicked={handleClose} /></div>
          <div><Button style={{ color: "#ffffff", backgroundColor: "#155EEF" }} btnName={"Submit"} disable={!Boolean(crmUsersList?.find(f => f?.value === selectedCrmUser?.value)?.crmUserDocUrl?.length > 0)} clicked={submitHandler}/></div>
        </div>
      </Box>
    </Modal>
    {openAlertBox && (
      <ConfirmationAlert
        confirm={(e) => {
          if(e === "confirmed"){
            handleReassignCRM();
          }else{
            setOpenAlertBox(false);
          }
        }}
        buttonTitle={"Cancel"}
        returnRespButton={"Continue"}
        close={() => setOpenAlertBox(false)}
        title={"Warning"}
        subTitle={`Are you sure! Do you want to link crm user - ${selectedCrmUser?.value}`}
        open={openAlertBox}
      />
      )}
    </>
  )
}

export default SelectCrmUserModal;
const labelStyle = {
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#344054",
  marginBottom: "0.8rem"
}